import { render, staticRenderFns } from "./SignInPC.vue?vue&type=template&id=1a266864&scoped=true&"
import script from "./SignInPC.vue?vue&type=script&lang=js&"
export * from "./SignInPC.vue?vue&type=script&lang=js&"
import style0 from "./SignInPC.vue?vue&type=style&index=0&id=1a266864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a266864",
  null
  
)

export default component.exports